
<style>
  @import '../cmdb.less';
  #basic_info_id li {
    list-style-type: none;
    padding: 8px 20px 8px 5px;
    border-bottom:1px dashed rgb(238, 238, 238);
    font-size: 13px;
    width: 50%;
    float: left;
  }
  .text-muted {
      color: #333;
      min-width: 85px;
      display: inline-block;
      text-align: right;
  }
  .text-info{
      margin-left: 20px;
      font-size: 13px;
      color: #333333;
  }
  .ivu-modal-confirm-footer{
      clear: both;
  }
  .ivu-btn-large{
      padding: 4px 15px 4px 15px;
      font-size: 12px;
  }
  .del{
    background: #f76162;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    text-align: center;
    margin-left: 56px;
    padding-top: 14px;
  }
  .del::after {
    content: '将机柜拖到此处删除';
    position: absolute;
    top: 30px;
    left: 60px;
    width: auto;
    margin-left: 68px;
    margin-top: 10px;
    color: #999;
    display: inline-block;
}
.del .ivu-icon{
  color:#fff;
}
</style>

<template>
  <div>
  <Card>
      <Row>
        <!-- <i-col span="18">
          <Form ref="searchForm" inline :model="searchForm" :label-width="60" @submit.native.prevent>
            <FormItem label="IDC" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入IDC名" style="width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0">
              <Button type="primary" @click="getCabinetList">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col> -->
       <col span="13">
        <draggable v-model="trashZone" class="dropzone trashzone" :options="trashOptions" style="float: left;">
          <div slot="footer" class="footer">
            <div class="del">
              <Icon :size="32" type="md-trash"></Icon>
            </div>
          </div>
        </draggable>
       </col>
        <i-col>
          <Button style="float: right;" @click="AddJg" type="primary" :style="{marginBottom: '10px'}">添加机柜</Button>
        </i-col>
       </Row>
      <Drawer
        title="添加主机"
        v-model="change"
        width="720"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <FormItem label="主机名" prop="name">
            <i-select v-model="formItem.name" style="width: 500px">
              <i-option v-for="item in hostList" :value="item.hostname" :key="item.id" :label="item.hostname"></i-option>
            </i-select>
            </FormItem>
            <FormItem label="位置"  :label-width="100" prop="address_end">
              <InputNumber :max="41" :min="1" v-model="formItem.address_start"></InputNumber>--<InputNumber :max="41" :min="1" v-model="formItem.address_end"></InputNumber>
            </FormItem>
            <form-item label="主机类型" prop="type">
              <RadioGroup v-model="formItem.type" type="button">
                <Radio :label="item.value" v-for="item in hostTypeArr" :key="item.value">{{ item.label }}</Radio>
              </RadioGroup>
            </form-item>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
       <Drawer
        title="添加"
        v-model="changeJg"
        width="720"
        :mask-closable="true"
        @on-close="drawerCloseJg"
      >
        <i-form ref="formItemJg" :model="formItemJg" :label-width="100" :rules="ruleValidate">
          <form-item label="机柜名称" prop="name">
             <i-input  v-model="formItemJg.name" placeholder="请输入机柜名称"></i-input>
          </form-item>
          <form-item label="机柜高度" prop="row_height">
              <InputNumber :max="50" :min="1" v-model="formItemJg.row_height"></InputNumber>
          </form-item>
          <form-item label="IDC" prop="idc">
             <i-select v-model="formItemJg.idc" style="width: 90%;">
              <i-option v-for="item in idcList" :value="item.id" :key="item.id" :label="item.name"></i-option>
             </i-select>
          </form-item>
          <form-item label="描述" prop="description">
             <i-input  v-model="formItemJg.description" placeholder="请输入机柜描述"></i-input>
          </form-item>
          <form-item>
           <i-button type="primary" @click="handleSubmitJg('formItemJg')">提交</i-button>
           <i-button style="margin-left: 8px" @click="changeJg=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
      </Card>
    <Card :bordered="false">
        <Row style="margin: 10px;">
          <draggable v-for="item in cabinetList" :key="item.id"  @start="start" @end="end($event, item.id)">
          <i-col :key="item.id" span="5" class="dropitem">
            <svg width="200" height="1000" viewBox="0 0 200 1000">
              <rect fill='#18243b' width="200" height="970">
              </rect>
              <text x="80" y="20" fill="#fff">{{ item.name }}</text>
              <!-- <HostItemNum  @click.native="viewDetail(m.name)" v-for="m in item.host_cabinet" :key="m.address_start"  :hostList = "m" :row_height = "item.row_height" /> -->
              <HostItem  @click.native="viewDetail(m.name, m.address_end, m.address_start, item.id, m.hostId)" v-for="m in item.host_cabinet" :key="m.address_start"  :hostList = "m" :row_height = "item.row_height"/>
            </svg>
         </i-col>
         </draggable>
        </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { GetALLUsers } from '@/api/user'
import cagehosthSvg from '@/assets/images/idc/cagehosth.svg'
import { getBaseMonitorOne } from '@/api/monitor'
import { getIdcList, saveJg, saveJgHost, getCabinetList, editJgHost, deleteJgHost, deleteJg, getHostLedTxt } from '@/api/idc'
import { getOpsCenterAllServer } from '@/api/opscenter'
// import dayjs from 'dayjs'
import HostItem from './HostItem'
import HostItemNum from './HostItemNum'
import draggable from 'vuedraggable'
export default {
  name: 'CabinetList',
  components: {
    Tables,
    draggable,
    'HostItem': HostItem,
    'HostItemNum': HostItemNum
  },
  data () {
    const validateAddressEnd = (rule, value, callback) => {
      // console.log(value)
      // console.log(this.formItem.address_start)
      if (value < this.formItem.address_start) {
        callback(new Error('结束位置不能比起始位置小 !'))
      } else {
        callback()
      }
    }
    return {
      hostLedTxt: '',
      trashOptions: {
        group: {
          name: 'trash',
          draggable: '.dropitem',
          put: () => true,
          pull: false
        }
      },
      trashZone: [],
      cagehosthSvg,
      count: 1,
      size: 10,
      page: 1,
      idcId: null,
      idcList: [],
      hostList: [],
      change: false,
      changeJg: false,
      ordering: null,
      cabinetList: [],
      cabinetListTmp: [],
      hostCabinetEmpty: [],
      user_all: [],
      changeLoadingShow: false,
      hostData: {},
      addressStartEdit: null,
      addressEndEdit: null,
      searchForm: {
        name: null
      },
      formItem: {
        id: null,
        name: '',
        address_start: 1,
        address_end: 1,
        idc: this.$route.query.id,
        cabinet: null,
        type: ''
      },
      formItemJg: {
        name: '',
        row_height: 42,
        idc: this.$route.query.id,
        description: ''
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        name: [{ required: true, message: '主机不能为空 !', trigger: 'change' }],
        address_end: [
          { required: true, validator: validateAddressEnd, trigger: 'blur' }
        ]
      },
      hostTypeArr: [
        { 'label': 'IBM', 'value': 'ibm' },
        { 'label': '联想', 'value': 'lenovo' },
        { 'label': '戴尔', 'value': 'dell' }
      ]
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.getCabinetList()
        this.idcId = this.$route.query.id
      }
    }
  },
  methods: {
    getAssetOptions () {
      getOpsCenterAllServer().then(res => {
        this.hostList = res.data.filter(item => item.hostname !== '')
      })
      // console.log(this.hostList)
    },
    AddJg () {
      this.changeJg = true
      this.formItemJg.name = ''
      this.formItemJg.idc = this.$route.query.id
      this.formItemJg.rowHeight = 30
      this.formItemJg.description = ''
    },
    handleSubmitJg (name) {
      // let that = this.formItem
      // console.log(this.formItemJg)
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          saveJg(this.formItemJg).then(res => {
            if (res.data.id > 0) {
              this.changeJg = false
              this.getCabinetList()
            } else {
              // this.$Notice.error({title: res.data})
              this.$Message.error(res.data.msg)
            }
          }).catch(res => {
            // console.log(res.response)
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
        this.changeLoadingShow = false
      })
    },
    getCabinetList () {
      let that = this
      // this.cabinetListTmp = [{'id': 1, 'name': '机柜1', 'idc': 1, 'row_height': '42', 'description': '', 'deleted': false, 'host_cabinet': [{'id': 2, 'name': 'ubuntu84', 'idc': '深圳机房1', 'description': null, 'address_start': '20', 'address_end': '21', 'cabinet': 1, 'alarm_level': '1', 'ip_main': '10.1.2.176', 'category': '虚拟机', 'cage_direction': 'X', 'cage_num': null}, {'id': 5, 'name': 'ceph86', 'idc': '深圳机房1', 'description': null, 'address_start': '26', 'address_end': '28', 'cabinet': 1, 'alarm_level': '1', 'ip_main': '10.1.2.176', 'category': '虚拟机', 'cage_direction': 'X', 'cage_num': null}, {'id': 5, 'name': 'ceph85', 'idc': '深圳机房1', 'description': null, 'address_start': '33', 'address_end': '33', 'cabinet': 1, 'alarm_level': '1', 'ip_main': '10.1.2.176', 'category': '虚拟机', 'cage_direction': 'X', 'cage_num': null}]}, {'id': 2, 'name': '机柜2', 'idc': 1, 'row_height': '42', 'description': '', 'deleted': false, 'host_cabinet': [{'id': 2, 'name': '10.1.2.176', 'idc': '深圳机房1', 'description': null, 'address_start': '30', 'address_end': '35', 'cabinet': 1, 'alarm_level': '1', 'ip_main': '10.1.2.176', 'category': '虚拟机', 'cage_direction': 'X', 'cage_num': null}]}]
      getCabinetList(that.$route.query.id).then(res => {
        // 不用深拷贝，每次调用api 后的 res.data 已经是一个新的对象
        // resultData = JSON.parse(JSON.stringify(res.data))
        that.cabinetListTmp = res.data['cabinet_set']
        // console.log(that.cabinetListTmp)
        // 遍历机柜数组，判断如果机柜上空的位置，填充一个空的Host (只有数字，没有主机图片)
        that.cabinetList = []
        that.cabinetListTmp.map((item, index) => {
          let hostCabinets = []
          let hostTmp = []
          item.host_cabinet.forEach(j => {
            that.getGreenOrRed(j.name)
            // console.log(isFalse)
            let host = { address_start: null, address_end: null, imageShow: false, name: null, isRed: false, isGreen: false, isOrange: false, hostName: null, hostId: null, type: null }
            host.address_start = parseInt(j.address_start)
            host.address_end = parseInt(j.address_end)
            host.hostId = j.id
            host.imageShow = true
            // host.isRed = (!isFalse) && host.imageShow
            // host.isGreen = isFalse && host.imageShow
            host.name = j.name
            host.hostName = j.name
            host.type = j.type
            // 判断当前这个主机占用多少个格子，用相同的host 填充即可
            let num = parseInt(j.address_end) - parseInt(j.address_start)
            // console.log(num)
            for (let n = 0; n <= num; n++) {
              let hostCp = JSON.parse(JSON.stringify(host))
              hostCp.address_start = hostCp.address_start + n
              if (n !== 0) {
                hostCp.hostName = ''
                hostCp.type = ''
              }
              hostTmp.push(hostCp.address_start)
              hostCabinets.push(hostCp)
            }
          })
          // console.log(hostCabinets)
          for (let i = 1; i < parseInt(item.row_height); i++) {
            let host = { address_start: null, address_end: null, imageShow: false, name: null, isRed: false, isGreen: false, isOrange: false, hostName: null, hostId: null, type: null }
            if (hostTmp.indexOf(i) === -1) {
              host.address_start = i
              host.imageShow = false
              host.name = ''
              hostCabinets.push(host)
            }
          }
          hostCabinets.sort(function (a, b) {
            return b.address_start - a.address_start
          })
          item['host_cabinet'] = hostCabinets
          that.cabinetList.push(item)
        })
      })
    },
    viewDetail (name, addressEnd, addressStart, jgId, hostId) {
      if (name) {
        this.handleRenderDetail(name, addressStart, addressEnd, jgId, hostId)
      } else {
        this.$Modal.confirm({
          width: '300px',
          title: '无主机信息',
          content: '<p>是否要在当前位置添加主机？</p>',
          onOk: () => {
            this.AddHost(addressStart, jgId, this.$route.query.id)
          }
        })
      }
    },
    // 机柜上新增主机
    AddHost (addressStart, jgId, idcId) {
      this.formItem.id = null
      this.formItem.name = ''
      this.formItem.idc = idcId
      this.formItem.cabinet = jgId
      this.formItem.address_start = addressStart
      this.formItem.address_end = addressStart
      this.change = true
    },
    // 取到主机监控数据弹窗显示
    handleRenderDetail (name, addressStart, addressEnd, jgId, hostId) {
      console.log(name)
      // 获取LED液晶面板文字
      let data = {
        'host': '10.1.1.179'
      }
      getHostLedTxt(data).then(res => {
        this.hostLedTxt = res.data
      })
      // 调用监控 api 取监控数据
      let hostnames = [name]
      let reqParams = {
        'hostnames': hostnames,
        'counters': ['hw.bios', 'hw.board_temp', 'hw.cmos_bat', 'hw.cpu', 'hw.cpu_temp', 'hw.fan', 'hw.memory', 'hw.pdisk', 'hw.power', 'hw.raidcard', 'hw.vdisk']
      }
      getBaseMonitorOne(reqParams).then(monitorRes => {
        let hostname = hostnames[0]
        let MonitorDataResult = monitorRes.data
        if (MonitorDataResult.code === 200) {
          let bios = null
          let boardTemp = null
          let cmosBat = null
          let cpu = null
          let cpuTemp = null
          let fan = null
          let memory = null
          let pdisk = null
          let power = null
          let raidcard = null
          let vdisk = null
          if (MonitorDataResult.data[hostname]) {
            if (MonitorDataResult.data[hostname]['timestamp']) {
              bios = MonitorDataResult.data[hostname]['hw.bios']
              boardTemp = MonitorDataResult.data[hostname]['hw.board_temp']
              cmosBat = MonitorDataResult.data[hostname]['hw.cmos_bat']
              cpu = MonitorDataResult.data[hostname]['hw.cpu']
              cpuTemp = MonitorDataResult.data[hostname]['hw.cpu_temp']
              fan = MonitorDataResult.data[hostname]['hw.fan']
              memory = MonitorDataResult.data[hostname]['hw.memory']
              pdisk = MonitorDataResult.data[hostname]['hw.pdisk']
              power = MonitorDataResult.data[hostname]['hw.power']
              raidcard = MonitorDataResult.data[hostname]['hw.raidcard']
              vdisk = MonitorDataResult.data[hostname]['hw.vdisk']
            }
          }
          this.hostData['bios'] = bios === 2 ? '正常' : (bios === 1 ? '警告' : '错误')
          this.hostData['board_temp'] = boardTemp
          this.hostData['cmos_bat'] = cmosBat === 2 ? '正常' : (cmosBat === 1 ? '警告' : '错误')
          this.hostData['cpu'] = cpu === 2 ? '正常' : (cpu === 1 ? '警告' : '错误')
          this.hostData['cpu_temp'] = cpuTemp
          this.hostData['fan'] = fan === 2 ? '正常' : (fan === 1 ? '警告' : '错误')
          this.hostData['memory'] = memory === 2 ? '正常' : (memory === 1 ? '警告' : '错误')
          this.hostData['pdisk'] = pdisk === 2 ? '正常' : (pdisk === 1 ? '警告' : '错误')
          this.hostData['power'] = power
          this.hostData['raidcard'] = raidcard === 2 ? '正常' : (raidcard === 1 ? '警告' : '错误')
          this.hostData['vdisk'] = vdisk === 2 ? '正常' : (vdisk === 1 ? '警告' : '错误')
          // console.log(this.hostData)
          // 显示数据
          this.$Modal.info({
            width: '450px',
            height: '550px',
            title: hostname + '监控详情',
            okText: '关闭',
            render: (h) => {
              return h('Tabs', [
                h('TabPane', { props: { label: '监控详情' } }, [
                  h('div', [
                    h('ul', { attrs: { id: 'basic_info_id' } }, [
                      h('li', [ h('span', { class: 'text-muted' }, 'BIOS:'), h('span', { class: 'text-info', style: { color: this.hostData['bios'] === '正常' ? 'green' : (this.hostData['bios'] === '警告' ? 'orange' : 'red') } }, this.hostData['bios']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, '主板温度:'), h('span', { class: 'text-info' }, this.hostData['board_temp']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, '电池状态:'), h('span', { class: 'text-info', style: { color: this.hostData['cmos_bat'] === '正常' ? 'green' : (this.hostData['cmos_bat'] === '警告' ? 'orange' : 'red') } }, this.hostData['cmos_bat']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, 'CPU状态:'), h('span', { class: 'text-info', style: { color: this.hostData['cpu'] === '正常' ? 'green' : (this.hostData['cpu'] === '警告' ? 'orange' : 'red') } }, this.hostData['cpu']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, 'CPU温度:'), h('span', { class: 'text-info' }, this.hostData['cpu_temp']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, 'CPU风扇状态:'), h('span', { class: 'text-info', style: { color: this.hostData['fan'] === '正常' ? 'green' : (this.hostData['fan'] === '警告' ? 'orange' : 'red') } }, this.hostData['fan']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, '内存状态:'), h('span', { class: 'text-info', style: { color: this.hostData['memory'] === '正常' ? 'green' : (this.hostData['memory'] === '警告' ? 'orange' : 'red') } }, this.hostData['memory']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, '物理磁盘状态:'), h('span', { class: 'text-info', style: { color: this.hostData['pdisk'] === '正常' ? 'green' : (this.hostData['pdisk'] === '警告' ? 'orange' : 'red') } }, this.hostData['pdisk']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, '电压:'), h('span', { class: 'text-info' }, this.hostData['power']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, '阵列卡状态:'), h('span', { class: 'text-info', style: { color: this.hostData['raidcard'] === '正常' ? 'green' : (this.hostData['raidcard'] === '警告' ? 'orange' : 'red') } }, this.hostData['raidcard']) ]),
                      h('li', [ h('span', { class: 'text-muted' }, '虚拟磁盘状态:'), h('span', { class: 'text-info', style: { color: this.hostData['vdisk'] === '正常' ? 'green' : (this.hostData['vdisk'] === '警告' ? 'orange' : 'red') } }, this.hostData['vdisk']) ])
                    ])
                  ])
                ]),
                h('TabPane', { props: { label: '液晶面板' } }, [
                  h('div', [
                    h('ul', [
                      h('li', this.hostLedTxt)
                    ])
                  ])
                ]),
                h('TabPane', { props: { label: '修改删除' } }, [
                  h('div', [
                    h('span', '位置:  '),
                    h('InputNumber', {
                      props: {
                        value: addressStart,
                        min: 1,
                        max: 41
                      },
                      on: {
                        input: (val) => {
                          this.addressStartEdit = val
                        }
                      }
                    }),
                    h('span', '--'),
                    h('InputNumber', {
                      props: {
                        value: addressEnd,
                        min: 1,
                        max: 41
                      },
                      on: {
                        input: (val) => {
                          this.addressEndEdit = val
                        }
                      }
                    }),
                    h('span', ' '),
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        title: '修改'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editHost(hostname, hostId, jgId)
                        }
                      }
                    }, '修改'),
                    h('Button', {
                      props: {
                        type: 'error',
                        size: 'small',
                        title: '删除'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.deleteHost(hostname, hostId)
                        }
                      }
                    }, '删除')
                  ])
                ])
              ])
            }
          })
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！',
            desc: MonitorDataResult.msg
          })
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取监控数据失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // 取到主机是否有错误，只要有错误就显示红灯，没错误显示绿灯
    getGreenOrRed (name) {
      // console.log(name)
      let that = this
      // 调用监控 api 取监控数据
      let hostnames = [name]
      let reqParams = {
        'hostnames': hostnames,
        'counters': ['hw.bios', 'hw.board_temp', 'hw.cmos_bat', 'hw.cpu', 'hw.cpu_temp', 'hw.fan', 'hw.memory', 'hw.pdisk', 'hw.power', 'hw.raidcard', 'hw.vdisk']
      }
      getBaseMonitorOne(reqParams).then(monitorRes => {
        let hostname = hostnames[0]
        let MonitorDataResult = monitorRes.data
        if (MonitorDataResult.code === 200) {
          let isError = false
          let isWarn = false
          let isGreen = false
          let bios = null
          // let boardTemp = null
          let cmosBat = null
          let cpu = null
          // let cpuTemp = null
          let fan = null
          let memory = null
          let pdisk = null
          // let power = null
          let raidcard = null
          let vdisk = null
          if (MonitorDataResult.data[hostname]) {
            if (MonitorDataResult.data[hostname]['timestamp']) {
              bios = MonitorDataResult.data[hostname]['hw.bios']
              // boardTemp = MonitorDataResult.data[hostname]['hw.board_temp']
              cmosBat = MonitorDataResult.data[hostname]['hw.cmos_bat']
              cpu = MonitorDataResult.data[hostname]['hw.cpu']
              // cpuTemp = MonitorDataResult.data[hostname]['hw.cpu_temp']
              fan = MonitorDataResult.data[hostname]['hw.fan']
              memory = MonitorDataResult.data[hostname]['hw.memory']
              pdisk = MonitorDataResult.data[hostname]['hw.pdisk']
              // power = MonitorDataResult.data[hostname]['hw.power']
              raidcard = MonitorDataResult.data[hostname]['hw.raidcard']
              vdisk = MonitorDataResult.data[hostname]['hw.vdisk']
              // 如果值都是空的，则显示错误，红灯
              if (bios === -1 || bios === '') {
                isError = true
              } else {
                // 有一个错误 就isError = true
                bios = MonitorDataResult.data[hostname]['hw.bios'] === 0
                cmosBat = MonitorDataResult.data[hostname]['hw.cmos_bat'] === 0
                cpu = MonitorDataResult.data[hostname]['hw.cpu'] === 0
                fan = MonitorDataResult.data[hostname]['hw.fan'] === 0
                memory = MonitorDataResult.data[hostname]['hw.memory'] === 0
                pdisk = MonitorDataResult.data[hostname]['hw.pdisk'] === 0
                raidcard = MonitorDataResult.data[hostname]['hw.raidcard'] === 0
                vdisk = MonitorDataResult.data[hostname]['hw.vdisk'] === 0
                // power = false
                // boardTemp = false
                // cpuTemp = false
                isError = bios || cmosBat || cpu || fan || memory || pdisk || raidcard || vdisk
                // 无错误，有警告 就isError = true
                bios = MonitorDataResult.data[hostname]['hw.bios'] === 1
                cmosBat = MonitorDataResult.data[hostname]['hw.cmos_bat'] === 1
                cpu = MonitorDataResult.data[hostname]['hw.cpu'] === 1
                fan = MonitorDataResult.data[hostname]['hw.fan'] === 1
                memory = MonitorDataResult.data[hostname]['hw.memory'] === 1
                pdisk = MonitorDataResult.data[hostname]['hw.pdisk'] === 1
                raidcard = MonitorDataResult.data[hostname]['hw.raidcard'] === 1
                vdisk = MonitorDataResult.data[hostname]['hw.vdisk'] === 1
                isWarn = (!isError) && (bios || cmosBat || cpu || fan || memory || pdisk || raidcard || vdisk)
                // console.log(hostname)
                // console.log(bios || cmosBat || cpu || fan || memory || pdisk || raidcard || vdisk)
                // 无错误，无警告，显示绿灯
                isGreen = (!isError) && (!isWarn)
              }
            } else {
              isError = true
            }
            that.cabinetList.map((item, index) => {
              item['host_cabinet'].map(j => {
                if (j.name === hostname) {
                  j.isRed = isError
                  j.isGreen = isGreen
                  j.isOrange = isWarn
                }
              })
            })
          }
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！',
            desc: MonitorDataResult.msg
          })
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取监控数据失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
      return true
    },
    editHost (name, hostId, jgId) {
      if (this.addressEndEdit < this.addressStartEdit) {
        this.$Message.error('不能小于起始位置')
        return
      }
      this.formItem.id = hostId
      this.formItem.name = name
      this.formItem.address_start = this.addressStartEdit
      this.formItem.address_end = this.addressEndEdit
      this.formItem.cabinet = jgId
      editJgHost(this.formItem).then(res => {
        if (res.data.code === 200) {
          this.getCabinetList()
        } else {
          this.$Message.error(res.data.msg)
        }
      }).catch(res => {
        console.log(res.response)
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    deleteHost (name, hostId) {
      deleteJgHost(hostId).then(res => {
        if (res.status === 204) {
          this.$Message.success('删除成功')
          this.getCabinetList()
        } else {
          this.$Message.error('删除失败')
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.name = null
      that.address_start = 1
      that.address_end = 1
      that.cabinet = null
    },
    drawerCloseJg () {
      let that = this.formItemJg
      that.name = ''
      that.description = ''
    },
    fetchAllUserData () {
      GetALLUsers().then(res => {
        this.user_all = res.data
      })
    },
    searchReset () {
      this.searchForm.name = null
    },
    validAddressEnd (value) {
      if (this.formItem.address_end < this.formItem.address_start) {
        this.formItem.address_end = this.formItem.address_start
        this.$Message.error('不能小于起始位置')
      }
    },
    handleSubmit (name) {
      // let that = this.formItem
      // console.log(this.formItem)
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          if (this.formItem.id) {
            // editJgHost(this.formItem).then(res => {
            //   if (res.data.code === 200) {
            //     this.change = false
            //     this.getCabinetList()
            //   } else {
            //     // this.$Notice.error({title: res.data})
            //     this.$Message.error(res.data.msg)
            //   }
            // }).catch(res => {
            //   console.log(res.response)
            //   this.$Notice.error({
            //     title: '操作失败！ 错误状态码:' + res.request.status,
            //     desc: res.request.responseText
            //   })
            // })
          } else {
            saveJgHost(this.formItem).then(res => {
              if (res.data.id > 0) {
                this.change = false
                this.getCabinetList()
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data.msg)
              }
            }).catch(res => {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          }
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
        this.changeLoadingShow = false
      })
    },
    getIdcList () {
      let that = this
      // this.idcList = [{'id': 1, 'name': '深圳机房1', 'account': null, 'account_id': null, 'bandwidth': null, 'host_count': 3, 'linkman': null, 'phone': null, 'address': null, 'date_added': '2018-10-13', 'deleted': false, 'description': null, 'type': '0', 'cabinet_set': []}, {'id': 2, 'name': '深圳机房1', 'account': null, 'account_id': null, 'bandwidth': null, 'host_count': 3, 'linkman': null, 'phone': null, 'address': null, 'date_added': '2018-10-13', 'deleted': false, 'description': null, 'type': '0', 'cabinet_set': [{'id': 1, 'name': '机柜1', 'idc': 1, 'row_height': '42', 'description': '', 'deleted': false, 'host_cabinet': [{'id': 2, 'name': '10.1.2.176', 'idc': '深圳机房1', 'description': null, 'address_start': '6', 'address_end': '8', 'cabinet': 1, 'alarm_level': '1', 'ip_main': '10.1.2.176', 'category': '虚拟机', 'cage_direction': 'X', 'cage_num': null}]}]}]
      getIdcList().then(res => {
        that.idcList = res.data
      })
    },
    start (event) {
      // console.log('start', event)
    },
    end (event, value) {
      event.preventDefault()
      if (event.to.className === 'dropzone trashzone') {
        // 调用api接口删除机柜
        deleteJg(value).then(res => {
          this.$Message.success('删除成功')
        })
      }
    }
  },
  mounted: function () {
    this.getCabinetList()
    this.getIdcList()
    this.getAssetOptions()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
.dropzone {
  border: 1px dotted red;
  margin: .1rem;
  min-height: 10vh;
  width: 30%;
  position: relative;
}

.trashzone .dropitem {
  display: none;
}

.trashzone .footer {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: center;
  padding-top: 2vh;
}

.trashzone .dropitem + .footer {
  background: red;
  color: white;
}
</style>
